module.exports = __webpack_public_path__ + "static/media/3.86e08ce7.png";